<div class="container padding-bottom-3x mb-2">
  <div class="row">

    <div class="col-md-4">
      <app-user-info-wrapper></app-user-info-wrapper>

    </div>
    <div class="col-md-8">
      <div class="padding-top-2x mt-2 hidden-lg-up"></div>
      <h4>{{'Temple'|translate}} Profile</h4>
      <hr class="padding-bottom-1x">
      <form autocomplete="off" class="row" [formGroup]="templeProfileForm">
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="{{'Temple'|translate}} {{'Name'|translate}}" formControlName="name" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('name').hasError('required')">
              {{'Temple'|translate}} name {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('name')" [field]="'Temple Profile'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="Main {{'Deity'|translate}}" formControlName="mainDeity" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('mainDeity').hasError('required')">
              Main deity name {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('mainDeity')" [field]="'Main deity name'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="{{'Account'|translate}} {{'Number'|translate}}" formControlName="accountNo" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('accountNo').hasError('required')">
              {{'Account'|translate}} {{'number'|translate}} {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('accountNo')" [field]="'Account Number'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="IFSC code" formControlName="ifscCode" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('ifscCode').hasError('required')">
              IFSC code {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('ifscCode')" [field]="' IFSC code '">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="History" formControlName="history" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('history').hasError('required')">
              History {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('history')" [field]="'History'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="{{'Temple'|translate}} {{'Code'|translate}}" formControlName="templeCode" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('templeCode').hasError('required')">
              {{'Temple'|translate}} code {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('templeCode')" [field]="'Temple Code'">
            </show-errors>
          </div>
        </div>
        <div class="col-12 padding-top-1x">
          <div class="form-check d-block">
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <h4>{{'Temple'|translate}} {{'Address'|translate}}</h4>
          </div>
        </div>
        <hr class="padding-bottom-1x">
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="{{'Address'|translate}} Line 1" formControlName="address1" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="{{'Address'|translate}} Line 2" formControlName="address2" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="Post" formControlName="post" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('post').hasError('required')">
              Post {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('post')" [field]="'Post'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="City" formControlName="city" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('city').hasError('required')">
              City {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('city')" [field]="'City'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="District" formControlName="district" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('district').hasError('required')">
              District {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('district')" [field]="'District'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="State" formControlName="state" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('state').hasError('required')">
              State {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('state')" [field]="'State'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="Country" formControlName="country" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('country').hasError('required')">
              Country {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('country')" [field]="'Country'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" pattern="[1-9][0-9]{5}" type="text" placeholder="Pincode" formControlName="pincode" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('pincode').hasError('required')">
              Pincode {{'is required'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('pincode')" [field]="'Pincode'">
            </show-errors>
            <small class="text-danger" *ngIf="submitted && templeProfileForm.get('pincode').hasError('pattern')">
              Invalid pincode
            </small>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="phoneNumber"  placeholder="Mobile {{'Number'|translate}}" formControlName="mobile" required>
            <!-- <small class="text-danger" *ngIf="submitted && templeProfileForm.get('mobile').hasError('required')">
              Mobile {{'is required'|translate}}
            </small>
            <small class="text-danger" *ngIf="submitted && templeProfileForm.get('mobile').hasError('pattern')">
              Invalid mobile {{'number'|translate}}
            </small> -->
            <show-errors *ngIf="submitted" [control]="templeProfileForm.get('mobile')" [field]="'Mobile'">
            </show-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">
            <input class="form-control" type="text" placeholder="{{'Phone'|translate}} {{'Number'|translate}}" formControlName="phone" required>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 ">

            <input class="form-control" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" type="text" placeholder="{{'Email'|translate}}" formControlName="email"
              required>
            <small class="text-danger" *ngIf="submitted && templeProfileForm.get('email').hasError('required')">
              {{'Email'|translate}} {{'is required'|translate}}
            </small>
            <small class="text-danger" *ngIf="submitted && templeProfileForm.get('email').hasError('pattern')">
              {{'Email'|translate}} format should be johndoe.com.
            </small>
          </div>
        </div>
        <div class="col-12 padding-top-1x">
          <div class="form-check d-block">
          </div>
          <div class="text-end" *ngIf="!!user.hasTempleDetails">
            <button class="btn btn-primary margin-bottom-none" type="button" data-toast="" data-toast-position="topRight" data-toast-type="success"
              data-toast-icon="icon-circle-check" data-toast-title="Success!" data-toast-message="Your address updated successfuly."
              (click)="updateProfile()">Update Profile</button>
          </div>
          <div class="text-end" *ngIf="!user.hasTempleDetails">
            <button class="btn btn-primary margin-bottom-none" type="button" data-toast="" data-toast-position="topRight" data-toast-type="success"
              data-toast-icon="icon-circle-check" data-toast-title="Success!" data-toast-message="Your address updated successfuly."
              (click)="updateProfile()">Add Profile</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>